import { getQuery, execQuery, luaScript } from '../../helpers/helper_store';

const state = {
	cron: null,
	idServer: null,
	historyList: null,
	historyFile: null,
	lastHistory: null
};

const mutations = {
	setCronServer: (state, data) => (state.idServer = data),
	setCron: (state, data) => (state.cron = data),
	setHistoryList: (state, data) => {
		if(!data) return;
		let newData = [];
		for (let line of data) {
			let newLine = line.split('');
			let entry = {
				fileName: line
			}
			// console.log(line);
			newLine.splice(4, 0, '/');
			newLine.splice(7, 0, '/');
			newLine.splice(10, 0, ' ');
			newLine.splice(13, 0, ':');
			newLine.splice(16, 0, ':');
			entry.nameView = newLine.join('');
			// console.log(newLine.join(''));
			newData.push(entry);
		}
		state.historyList = newData;
	},
	setHistoryFile: (state, data) => (state.historyFile = data),
	setLastHistory: (state, data) => (state.lastHistory = data)
};

const actions = {
	getCron({ rootState, commit, state }, idServer = state.idServer) {
		return new Promise((resolve, reject) => {
			getQuery('getCron', [ idServer ], rootState.login)
				.then((result) => {
					// console.log('getCron', result);
					commit('setCron', result);
					resolve(result);
				})
				.catch(() => {
					reject();
				});
		});
	},
	createCron({ rootState, dispatch }, idServer) {
		return new Promise((resolve, reject) => {
			execQuery('insCronTable', [ idServer ], rootState.login)
				.then(() => {
					return dispatch('getCron');
				})
				.then(() => {
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	exportCron({ rootState, state }, idCron = state.cron.id) {
		return new Promise((resolve, reject) => {
			luaScript('cronsend', 'save', { cronid: idCron }, rootState.login)
				.then(() => {
					resolve();
				})
				.catch(() => reject());
		});
	},
	previewExportCron({ rootState, state }, idCron = state.cron.id) {
		return new Promise((resolve, reject) => {
			luaScript('cronsend', 'test', { cronid: idCron }, rootState.login)
				.then((result) => {
					resolve(result);
				})
				.catch(() => reject());
		});
	},
	// ---------------------------- HISTORY ----------------------
	getHistoryList({ rootState, commit, state }, idCron = state.cron.id) {
		return new Promise((resolve, reject) => {
			luaScript('cronsend', 'list', { cronid: idCron }, rootState.login)
				.then((result) => {
					commit('setHistoryList', result);
					resolve();
				})
				.catch((error) => {
					// console.log(error);
					reject(error);
				});
		});
	},
	getHistoryFile({ rootState, commit, state }, { idCron = state.cron.id, logfile }) {
		return new Promise((resolve, reject) => {
			luaScript('cronsend', 'view', { cronid: idCron, logfile }, rootState.login)
				.then((result) => {
					commit('setHistoryFile', result);
					resolve();
				})
				.catch(() => reject());
		});
	},
	getLastHistory({ rootState, commit, state }, idCron = state.cron.id) {
		return new Promise((resolve, reject) => {
			luaScript('cronsend', 'view', { cronid: idCron, logfile: 'last' }, rootState.login)
				.then((result) => {
					commit('setLastHistory', result);
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	}
};

const getters = {
	cron: (state) => state.cron,
	serverSelected: (state) => state.idServer,
	historyList: (state) => state.historyList,
	historyFile: (state) => state.historyFile,
	lastHistory: (state) => state.lastHistory
};

export default {
	state,
	mutations,
	actions,
	getters
};
